export default __webpack_public_path__ + "static/media/rightArrow.0b0eb63b.svg";